import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import CreateBrandModal from "./CreateBrandModal";

const Brands = () => {
  const [brands, setBrands] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchBrands = async () => {
    const res = await api.get("companyblog/admin/brands/");
    setBrands(res.data);
  };

  useEffect(() => {
    fetchBrands();
  }, []);

  const toggleStatus = async (id) => {
    await api.patch(`companyblog/admin/brands/${id}/toggle/`);
    fetchBrands();
  };

  const deleteBrand = async (id) => {
    if (window.confirm("Are you sure?")) {
      await api.delete(`companyblog/admin/brands/${id}/delete/`);
      fetchBrands();
    }
  };

  return (
     <>
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h4>All Brands</h4>
          <button
            className="btn btn-info"
            onClick={() => setShowModal(true)}
          >
            + New Brand
          </button>
        </div>

        <table className="table table-bordered mb-0">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Brand Logo</th>
              <th>Name</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {brands.map((brand, index) => (
              <tr key={brand.brand_id}>
                <td>{index + 1}</td>
                <td>
                  <img src={brand.brand_image} alt={brand.brand_name} width="100" />
                </td>
                <td>{brand.brand_name}</td>
                <td>
                  <span
                    className={`badge ${
                      brand.is_active ? "bg-success" : "bg-danger"
                    }`}
                  >
                    {brand.is_active ? "Active" : "Inactive"}
                  </span>
                </td>
                <td>
                  <button
                    className={`btn btn-sm ${
                      brand.is_active ? "btn-warning" : "btn-success"
                    } me-2`}
                    onClick={() => toggleStatus(brand.brand_id)}
                  >
                    {brand.is_active ? "Deactivate" : "Activate"}
                  </button>

                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => deleteBrand(brand.brand_id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      <CreateBrandModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onCreated={fetchBrands}
      />
    </>
    );
};

export default Brands;
